<template>
  <div>
    <b-row>
      <b-col md="12">
        <InputSelect
          title="Condition"
          name="Condition"
          isRequired
          v-model="response.content.Condition.VariableId"
          :options="conditionList"
          valueField="id"
          textField="name"
          @onDataChange="handleChangeVariable"
          :isValidate="v.content.Condition.VariableId.$error"
          :v="v.content.Condition.VariableId"
          />
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <InputSelect
          title="Operation"
          name="Operation"
          isRequired
          v-model="response.content.Condition.SymbolId"
          :options="operationList"
          valueField="id"
          textField="name"
          @onDataChange="handleChangeSymbol"
          :isValidate="v.content.Condition.SymbolId.$error"
          :v="v.content.Condition.SymbolId"
        />
      </b-col>
      <b-col md="6">
        <InputText
          v-model="response.content.Condition.Value"
          textFloat="Value"
          placeholder="Value"
          type="text"
          name="Value"
          isRequired
          :isValidate="v.content.Condition.Value.$error"
          :v="v.content.Condition.Value"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" class="intent-true">
        <InputSelect
          title="True"
          name="ReplyMainIntentIdTrue"
          isRequired
          v-model="response.content.Condition.ReplyMainIntentIdTrue"
          :options="allFirstFlowList"
          valueField="mainIntentId"
          textField="intentName"
          @onDataChange="handleChangeTrue"
          :isValidate="v.content.Condition.ReplyMainIntentIdTrue.$error"
          :v="v.content.Condition.ReplyMainIntentIdTrue"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" class="intent-false">
        <InputSelect
          title="False"
          name="ReplyMainIntentIdFalse"
          isRequired
          v-model="response.content.Condition.ReplyMainIntentIdFalse"
          :options="allFirstFlowList"
          valueField="mainIntentId"
          textField="intentName"
          @onDataChange="handleChangeFalse"
          :isValidate="v.content.Condition.ReplyMainIntentIdFalse.$error"
          :v="v.content.Condition.ReplyMainIntentIdFalse"
          />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
export default {
  components: {
    InputSelect,
    InputText,
  },
  props: {
    conditionList: {
      required: true,
      type: Array,
    },
    allFirstFlowList: {
      required: true,
      type: Array,
    },
    operationList: {
      required: true,
      type: Array,
    },
    response: {
      required: true,
      type: Object
    },
    v: {
      required: false,
      type: Object
    }
  },
  data() {
    return {
      value: 0,
    };
  },
  methods: {
    handleChangeVariable(value) {
      this.response.content.Condition.VariableId = value;
    },
    handleChangeTrue(value){
      this.response.content.Condition.ReplyMainIntentIdTrue = value;
    },
    handleChangeFalse(value){
      this.response.content.Condition.ReplyMainIntentIdFalse = value;
    },
    handleChangeSymbol(value){
      this.response.content.Condition.SymbolId = value;
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .intent-true label {
  color: #2eb85c !important;
}
::v-deep .intent-false label {
  color: #e55353 !important;
}
</style>
